<ng-container *ngIf="job$ | async as job">
  <div
    *ngIf="!(compact$ | async); else compactJobListItem"
    class="job-list-item"
    [attr.data-cy]="'job-list-item-id-' + job?._id"
    [attr.data-cy-job-id]="job?._id"
    [class.is-canceled]="(dispoJobStatusArray$ | async)?.[0] === DispoJobStatus.CANCELED"
    [class.is-compact]="compact$ | async">
    <div class="status-bar-wrapper">
      <div
        *ngFor="let status of dispoJobStatusArray$ | async"
        class="status-bar"
        [matTooltip]="
          status === DispoJobStatus.ACTION_REQUIRED
            ? ('noOpenInvitations' | i18n | titlecase)
            : status === DispoJobStatus.BOOKED
            ? ('booked' | i18n | titlecase)
            : status === DispoJobStatus.AVAILABLE
            ? ('hasAvailablePeople' | i18n | titlecase)
            : status === DispoJobStatus.CANCELED
            ? ('jobCanceled' | i18n | titlecase)
            : ('waitingForResponse' | i18n | titlecase)
        "
        [matTooltipShowDelay]="100"
        matTooltipPosition="above"
        [class.status-action-required]="
          status === DispoJobStatus.ACTION_REQUIRED
        "
        [class.status-closed]="status === DispoJobStatus.BOOKED"
        [class.status-has-available-invitees]="
          status === DispoJobStatus.AVAILABLE
        "></div>
    </div>
    <div class="header-meta">
      <app-job-list-item-date-time
        [job]="job"
        [withDate]="!!(withDate$ | async)"></app-job-list-item-date-time>
      <div class="flex-grow"></div>
      <app-job-list-item-counts
        *ngIf="jobCounts$ | async as counts"
        [hidePotentialInviteeCount]="job.status !== jobStatusEnum.OPEN"
        [counts]="counts"></app-job-list-item-counts>
    </div>
    <app-job-list-item-organisation-heading
      [jobType]="job.multiDayId ? 'job-series' : 'job'"
      class="job-heading"
      [department]="job.department"
      [organisation]="
        job.organisation
      "></app-job-list-item-organisation-heading>
    <app-dispo-job-list-item-details-table
      class="details-table"
      [job]="job"
      [transferCounts]="(transferCounts$ | async) || undefined"
      [transferredToMeText]="
        (transferredToMeText$ | async) || undefined
      "></app-dispo-job-list-item-details-table>

    <ng-container *ngIf="overviewInvitees$ | async as overviewInvitees">
      <div
        *ngIf="overviewInvitees.length > 0 && (job$ | async) as job"
        class="invitees-preview-wrapper"
        data-cy="job-list-item-invitees">
        <app-job-invitee-list
          [job]="job"
          [invitees]="overviewInvitees"
          [jobCustomer]="(customerOfJob$ | async) || undefined"
          [loggedInUser]="(loggedInUser$ | async) || undefined"
          (click)="$event.stopPropagation()"
          [displayHeader]="false">
        </app-job-invitee-list>
      </div>
    </ng-container>

    <div class="job-footer">
      <div class="start-items">
        <div
          *ngIf="job?.orderId"
          class="order-id"
          data-cy="job-order-id"
          [matTooltip]="'orderId' | i18n">
          #{{ job.orderId }}
        </div>
      </div>
      <div class="end-items">
        <ng-container
          *ngIf="
            !job.requestRetractionRequestedAt;
            else compactRetractionRequestedActions
          ">
          <button
            *ngIf="canCancel$ | async"
            class="outline-pill-button text-error"
            type="button"
            data-cy="cancel-job-button"
            (click)="
              $event.stopPropagation(); jobEditService.startCancelJob(job)
            ">
            <mat-icon svgIcon="close"></mat-icon>
            {{ ("cancelItem" | i18n) || "stornieren" | titlecase }}
          </button></ng-container
        >
        <ng-template #compactRetractionRequestedActions>
          <button
            class="outline-pill-button"
            type="button"
            (click)="
              $event.stopPropagation();
              jobRequestService.rejectRetractionOnRequest(job._id)
            "
            data-cy="reject-retraction-on-request-button">
            <mat-icon svgIcon="do_not_disturb_on"></mat-icon>
            {{
              ("rejectRetractionOnRequest" | i18n) || "Zurückziehen ablehnen"
                | titlecase
            }}
          </button>
          <button
            class="outline-pill-button text-error"
            type="button"
            (click)="
              $event.stopPropagation();
              jobRequestService.approveRetractionOnRequest(job._id)
            "
            data-cy="approve-retraction-on-request-button">
            <mat-icon svgIcon="close"></mat-icon>
            {{
              ("approveRetractionOnRequest" | i18n) || "Zurückziehen freigeben"
                | titlecase
            }}
          </button>
        </ng-template>
        <button
          class="outline-pill-button icon-only"
          data-cy="more-actions-button"
          type="button"
          [matMenuTriggerFor]="actionsMenu"
          [matTooltip]="
            ('moreOptions' | i18n) || 'weitere optionen' | titlecase
          "
          (click)="$event.stopPropagation()">
          <mat-icon svgIcon="menu-dot"></mat-icon>
        </button>
      </div>
    </div>

    <mat-menu
      #actionsMenu="matMenu"
      class="fixed-icon-mat-menu themed">
      <button
        *ngIf="job.multiDayId"
        mat-menu-item
        type="button"
        data-cy="multiday-edit-button"
        (click)="$event.stopPropagation(); navigateToMultiDayEdit(job)">
        <mat-icon svgIcon="pencil-outline"></mat-icon>
        {{ "multiDayEdit" | i18n | titlecase }}
      </button>
      <button
        mat-menu-item
        type="button"
        data-cy="duplicate-job-button"
        (click)="$event.stopPropagation(); jobEditService.duplicateJob(job)">
        <mat-icon svgIcon="duplicate-copy"></mat-icon>
        {{ ("duplicate" | i18n) || "duplizieren" | titlecase }}
      </button>
    </mat-menu>
  </div>
  <ng-template #compactJobListItem>
    <div
      class="compact-job-list-item-row"
      [attr.data-cy]="'job-list-item-id-' + job?._id"
      [class.is-canceled]="(dispoJobStatusArray$ | async)?.[0] === DispoJobStatus.CANCELED">
      <div class="compact-job-list-item-backdrop"></div>
      <div class="status-bar-wrapper-container">
        <div class="status-bar-wrapper">
          <div
            *ngFor="let status of dispoJobStatusArray$ | async"
            class="status-bar"
            [matTooltip]="
              status === DispoJobStatus.ACTION_REQUIRED
                ? ('noOpenInvitations' | i18n | titlecase)
                : status === DispoJobStatus.BOOKED
                ? ('booked' | i18n | titlecase)
                : status === DispoJobStatus.AVAILABLE
                ? ('hasAvailablePeople' | i18n | titlecase)
                : ('waitingForResponse' | i18n | titlecase)
            "
            [matTooltipShowDelay]="100"
            matTooltipPosition="above"
            [class.status-action-required]="
              status === DispoJobStatus.ACTION_REQUIRED
            "
            [class.status-closed]="status === DispoJobStatus.BOOKED"
            [class.status-has-available-invitees]="
              status === DispoJobStatus.AVAILABLE
            "></div>
        </div>
      </div>
      <app-dispo-job-list-item-compact-content
        [job]="job"
        [counts]="(jobCounts$ | async) || undefined"
        [transferCounts]="(transferCounts$ | async) || undefined"
        [transferredToMeText]="(transferredToMeText$ | async) || undefined"
        [columns]="
          (columns$ | async) || []
        "></app-dispo-job-list-item-compact-content>
      <div class="compact-job-list-item-footer">
        <div
          *ngIf="hasOpenHoursToApprove$ | async"
          class="compact-job-list-item-timetracking">
          {{ ("checkHours" | i18n) || "Stunden prüfen" | titlecase }}
        </div>
        <div
          *ngIf="job.status === jobStatusEnum.CLOSED"
          class="compact-job-list-item-footer-info">
          <mat-icon
            svgIcon="info"
            class="info-icon"
            size="20"
            [matTooltip]="
              'closedJobTooltip'
                | i18n
                  : {
                      date:
                        job.updatedAt * 1000
                        | convertToDateObject
                        | displayDate: 'dd.MM.yyyy',
                      distance:
                        job.updatedAt * 1000
                        | convertToDateObject
                        | formatDistance
                    }
            "></mat-icon>
        </div>
        <button
          class="outline-pill-button icon-only"
          data-cy="more-actions-button"
          type="button"
          [matMenuTriggerFor]="compactActionsMenu"
          matTooltip="{{
            ('moreOptions' | i18n) || 'weitere optionen' | titlecase
          }}"
          (click)="$event.stopPropagation()">
          <mat-icon svgIcon="menu-dot"></mat-icon>
        </button>
      </div>
    </div>
    <mat-menu
      #compactActionsMenu="matMenu"
      class="fixed-icon-mat-menu themed">
      <ng-container
        *ngIf="
          !job.requestRetractionRequestedAt;
          else compactRetractionRequestedActions
        ">
        <button
          *ngIf="canCancel$ | async"
          mat-menu-item
          class="text-error"
          type="button"
          data-cy="cancel-job-button"
          (click)="
            $event.stopPropagation(); jobEditService.startCancelJob(job)
          ">
          <mat-icon svgIcon="close"></mat-icon>
          {{ ("cancelItem" | i18n) || "stornieren" | titlecase }}
        </button>
      </ng-container>
      <ng-template #compactRetractionRequestedActions>
        <button
          mat-menu-item
          class="text-error"
          type="button"
          data-cy="approve-retraction-on-request-button"
          (click)="
            $event.stopPropagation();
            jobRequestService.approveRetractionOnRequest(job._id)
          ">
          <mat-icon svgIcon="close"></mat-icon>
          {{
            ("approveRetractionOnRequest" | i18n) || "Zurückziehen freigeben"
              | titlecase
          }}
        </button>

        <button
          mat-menu-item
          type="button"
          data-cy="reject-retraction-on-request-button"
          (click)="
            $event.stopPropagation();
            jobRequestService.rejectRetractionOnRequest(job._id)
          ">
          <mat-icon svgIcon="do_not_disturb_on"></mat-icon>
          {{
            ("rejectRetractionOnRequest" | i18n) || "Zurückziehen ablehnen"
              | titlecase
          }}
        </button>
      </ng-template>
      <button
        *ngIf="job.multiDayId"
        mat-menu-item
        type="button"
        data-cy="multiday-edit-button"
        (click)="$event.stopPropagation(); navigateToMultiDayEdit(job)">
        <mat-icon svgIcon="pencil-outline"></mat-icon>
        {{ "multiDayEdit" | i18n | titlecase }}
      </button>
      <button
        mat-menu-item
        type="button"
        data-cy="duplicate-job-button"
        (click)="$event.stopPropagation(); jobEditService.duplicateJob(job)">
        <mat-icon svgIcon="duplicate-copy"></mat-icon>
        {{ ("duplicate" | i18n) || "duplizieren" | titlecase }}
      </button>
    </mat-menu>
  </ng-template>
</ng-container>
